export default function formatDate(date) {
  if (!date) return "Без даты";
  return new Date(date).toLocaleDateString();
}
